import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function footer() {
  return (
    <>
      <footer className="footer">
        <div className="container-fluid d-flex justify-content-center align-items-center h-100">
          <div className="text-center fw-bold w-100">
            © Copyright - Crm. All Right Reserved
          </div>
        </div>
      </footer>
    </>
  );
}
